import React from "react";
import ListView from "./ListView";
import { Link } from "react-router-dom";
import { FormGroup, Input } from "reactstrap";
import image_scooter from "../assets/img/scooter.jpg";
import { formatMoney } from "accounting";

const ContractsProductsList = ({ contracts, children }) => {
  return (
    <ListView items={contracts}>
      {contract => (
        <div className="row product-list-item">
          <div className="col-auto">
            <img className="image" src={image_scooter} alt="contracts" />
          </div>
          <div className="col">
            <div className="row">
              <div className="col">
                <p className="product-name">Service Contract</p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm">
                <p className="product-price">
                  <Link to={`/contracts/${contract.tracking_number}`}>
                    #{contract.tracking_number}
                  </Link>
                </p>
              </div>
              <div className="col-12 col-sm">
                <FormGroup inline>
                  <Input value="1" readOnly={true} />
                </FormGroup>
              </div>
              <div className="col-12 col-sm">
                <p className="product-price product-total">
                  {formatMoney(contract.total_cost_contract)}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-auto">
            {typeof children === "function" ? children({ contract }) : children}
          </div>
        </div>
      )}
    </ListView>
  );
};

export default ContractsProductsList;
